<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="10">

                <v-row justify="center" class="pt-2">
                    <v-col cols="12">
                        <v-alert
                                border="bottom"
                                text
                                color="primary"
                                elevation="2">
                            <v-row>
                                <v-col cols="12">
                                    <v-radio-group
                                            v-model="reportType"
                                            column
                                            mandatory
                                            color="primary">

<!--                                        <v-radio style="min-width: 420px;justify-content: center"-->
<!--                                                 filter-->
<!--                                                 outlined-->
<!--                                                 color="primary"-->
<!--                                                 value="bookDeliveries"-->
<!--                                                 label="Πλήθος Παραδόσεων Βιβλίων ανά Ίδρυμα">-->

<!--                                        </v-radio>-->

<!--                                        <v-radio style="min-width: 420px;justify-content: center"-->
<!--                                                 filter-->
<!--                                                 outlined-->
<!--                                                 color="primary"-->
<!--                                                 value="bookWrongDeliveries"-->
<!--                                                 label="Πλήθος Λανθασμένων Παραδόσεων Βιβλίων σε Φοιτητές">-->

<!--                                        </v-radio>-->

<!--                                        <v-radio style="min-width: 420px;justify-content: center"-->
<!--                                                 filter-->
<!--                                                 outlined-->
<!--                                                 color="primary"-->
<!--                                                 value="borrowedBooks"-->
<!--                                                 label="Πλήθος Παραδόσεων Βιβλίων υπο μορφή Δανεισμού σε Φοιτητές">-->

<!--                                        </v-radio>-->

<!--                                        <v-radio style="min-width: 420px;justify-content: center"-->
<!--                                                 filter-->
<!--                                                 outlined-->
<!--                                                 color="primary"-->
<!--                                                 value="libraryOrders"-->
<!--                                                 label="Αναφορά Παραγγελιών Βιβλιοθηκών (ετήσια)">-->

<!--                                        </v-radio>-->

                                        <v-radio style="min-width: 420px;justify-content: center"
                                                 filter
                                                 outlined
                                                 color="primary"
                                                 value="helpdeskSecretariatsWithCoursesAndBooksForLibraryApp"
                                                 label="Επιλεγμένα συγγράμματα ιδρύματος">

                                        </v-radio>

                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row>

                                <v-col class="py-0 caption text-center text--primary" cols="3" >
                                    <v-select outlined dense :disabled="!showYearFilter" :class="showYearFilter?'text-cyan':'textfield-disabled'" :items="$store.getters.yearsInfo.yearsList"
                                              v-model="selectedYear" item-value="year" item-text="yearLabel"
                                              label="Ακαδημαϊκό Έτος"/>
                                </v-col>

<!--                                <v-col class="py-0 caption text-center text&#45;&#45;primary" cols="3">-->
<!--                                    <v-select outlined dense :disabled="!showPeriodFilter" :class="showPeriodFilter?'text-cyan':'textfield-disabled'" :items="$store.getters.periodsForSelector01"-->
<!--                                              v-model="selectedPeriod" item-value="value" item-text="label"-->
<!--                                              label="Περίοδος" />-->
<!--                                </v-col>-->

                                <v-col class="py-0 caption text-center text--primary" cols="6" >
                                    <v-autocomplete :class="showInstitutionsFilter?'text-cyan':'textfield-disabled'" outlined dense :items="institutions" v-model="selectedInstitutionId" :disabled="!showInstitutionsFilter" item-text="name" item-value="id" label="Ίδρυμα"/>
                                </v-col>
                            </v-row>

                            <v-row justify="center">
                                <v-col cols="4">
                                    <v-btn @click="getReport" block color="primary" :disabled="disableSubmitButton">Δημιουργία Αναφοράς
                                        <v-icon color="white">mdi-arrow-down-bold</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-alert>


                    </v-col>
                </v-row>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import requests from "../requests";
    import utils from "../utilities";

	export default {
		name: "Reports",data: () =>({
			selectedYear: '',
			selectedInstitutionId: '',
			selectedAcademicId:'', //from this one we 'll get the secretariat
			reportType: '',
			selectedPeriod: null,
            institutions:[
	            {
		            id: 0,
		            name: 'Όλα'
	            }
            ],

			showInstitutionsFilter:true,
			showYearFilter:true,
			showPeriodFilter:true,

			requestReportObj: {
				type:null,
				format:'csv',
				academicYear:null,
				period:null,
				institutionId:null
			},
		}),

        computed:{

			disableSubmitButton(){
		        if(this.reportType === 'libraryOrders'){
			        return this.selectedYear === '';
		        }else if(this.reportType === 'helpdeskSecretariatsWithCoursesAndBooksForLibraryApp'){
			        return this.selectedInstitutionId === '' || this.selectedYear === '';
		        }else{
			        if(this.selectedYear === '' || this.selectedPeriod===null){
				        return true;
			        }
		        }
		        return false;
	        },
        },

		methods:{

            createRequestReportObj(){
				this.requestReportObj = {
                    type:this.reportType,
                    format:'csv',
                    academicYear:null,
                    period:null,
                    institutionId:null
				};

				if(this.showInstitutionsFilter){
					this.requestReportObj.institutionId = this.selectedInstitutionId===0 ? null : this.selectedInstitutionId;
                }
				if(this.showYearFilter){
					this.requestReportObj.academicYear = this.selectedYear;
                }
				if(this.showPeriodFilter){
					this.requestReportObj.period = this.selectedPeriod===0? 'Ximerino':'Earino';
                }

            },

			requestReports(){
				this.$store.commit('setLoadingModal', true);
				this.createRequestReportObj();
				console.log(this.requestReportObj);

				requests.put('rest/reports/status', this.requestReportObj, (resp)=>{
					console.log(resp);

					if(resp === 'MISSING'){
						requests.put('rest/reports/create', this.requestReportObj, ()=>{
							this.$store.commit('setLoadingModal', false);
							utils.setSuccessPopup('',  'Η δημιουργία αναφοράς ξεκίνησε.');
						})

					} else if(resp === 'PENDING'){
						this.$store.commit('setLoadingModal', false);
						    utils.setSuccessPopup('',  'Η διεργασία εκτελείται ήδη.');

					} else if(resp === 'CREATED'){
						requests.extractCsv('rest/reports/get', this.requestReportObj);
					}

				})
			},

			getReport(){
				this.$store.commit('setLoadingModal', true);

				if(this.reportType ==='bookDeliveries' || this.reportType ==='bookWrongDeliveries' || this.reportType ==='borrowedBooks'){
					requests.getReports('rest/reports/' + this.reportType + '/' + this.selectedYear + '/' + this.selectedPeriod);
				}else if(this.reportType ==='helpdeskSecretariatsWithCoursesAndBooksForLibraryApp'){
					this.requestReports();
				}else{
					requests.getReports('rest/reports/library-orders/' + this.selectedYear );
				}


			},

		},

		watch:{
			'reportType': function(val) {
				switch (val) {
					case 'bookDeliveries':
					case 'bookWrongDeliveries':
					case 'borrowedBooks':
						this.showYearFilter = true;
						this.showPeriodFilter = true;
						this.showInstitutionsFilter = false;
						break;
					case 'libraryOrders':
						this.showYearFilter = true;
						this.showPeriodFilter = false;
						this.showInstitutionsFilter = false;
						break;
					case 'helpdeskSecretariatsWithCoursesAndBooksForLibraryApp':
						this.showYearFilter = true;
						this.showPeriodFilter = false;
						this.showInstitutionsFilter = true;
						break;

				}
			}
		},

        created() {
			requests.get('rest/reports/institutions', (resp)=>{
				let arr = JSON.parse(JSON.stringify(resp));
				this.institutions.splice(1, 0, ...arr);
            })
        }
	}
</script>

<style scoped>

    .text-cyan >>> fieldset {
        border-color: #3AA8C3;

    }

    .text-cyan >>> input {
        color: #3AA8C3 !important;
    }

    .text-cyan >>> label {
        color: #3AA8C3 !important;
    }
    .text-cyan >>> .v-select__selections {
        color: #3AA8C3 !important; /* This will style the selected value text */
    }

</style>